export default __webpack_public_path__ + "static/media/arrow-down.37bab6c8.svg";